module.exports = __webpack_public_path__ + "img/Basiame Phillips.d24f593b.png";